import { useState, useEffect, useCallback } from 'react';

export const isBrowser = typeof window === 'object';

export const isIe = isBrowser && !!document.documentMode;

export const isEdge = isBrowser && window.navigator.userAgent.indexOf('Edge') > -1;

export const isTouchDevice = isBrowser && (('ontouchstart' in window)
|| (navigator.MaxTouchPoints > 0)
|| (navigator.msMaxTouchPoints > 0));

export const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState({
        width: undefined,
        hight: undefined,
    });

    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowSize;
};

export const useElementSize = () => {
    const [elementSize, setElementSize] = useState({
        width: undefined,
        hight: undefined,
    });

    const elementRef = useCallback((node) => {
        function handleResize() {
            if (node !== null) {
                setElementSize({
                    width: node.getBoundingClientRect().width,
                    height: node.getBoundingClientRect().height,
                });
            }
        }

        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return [elementRef, elementSize];
};
